export var ENTITY = "enabledAccount";
export var REDUCER_KEY = "ENABLED_ACCOUNT_V2";
// Not a real flat resource — the actual REST path is nested under a user id
// (/users/:userId/enabled-accounts). getPaged/getCount are always called with an
// explicit customPath built from BASE_PATH_ENTITY; this constant is not hit directly.
export var BASE_PATH_ENTITY = "enabled-accounts";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
export var getEnabledAccountsPath = function (userId) {
    return "/users/".concat(userId, "/").concat(BASE_PATH_ENTITY);
};
// Read by enabledAccountApi.getEnabledAccountsCount. Kept next to the list path so the
// two cannot drift; nothing outside the module needs to build this URL itself.
export var getEnabledAccountsCountPath = function (userId) {
    return "".concat(getEnabledAccountsPath(userId), "/count");
};
